package com.iregained.site.components.widgets.styles

import com.varabyte.kobweb.compose.css.AnimationIterationCount
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.selectors.hover
import org.gstechnovos.jexonplastech.theme.toSitePalette
import org.jetbrains.compose.web.css.*


/** Outer 16:9 container (uses the padding-bottom 56.25% trick). */
val YtCardWrapperStyle = CssStyle {
    base {
        Modifier.fillMaxWidth().position(Position.Relative)
            .borderRadius(20.px) // The aspect-ratio property will be injected dynamically!
            .overflow(Overflow.Hidden).backgroundColor(Colors.Black).cursor(Cursor.Pointer)
            .boxShadow(0.px, 18.px, 48.px, color = Colors.Black.copy(alpha = 22))
            .transition(Transition.of("transform", 300.ms), Transition.of("box-shadow", 300.ms))
    }
    hover {
        Modifier.transform { translateY((-4).px) }.boxShadow(0.px, 26.px, 60.px, color = Colors.Black.copy(alpha = 32))
    }
}

val YtPosterImageStyle = CssStyle.base {
    Modifier.position(Position.Absolute).top(0.px).left(0.px).fillMaxSize().objectFit(ObjectFit.Cover)
}

val YtPosterGradientStyle = CssStyle.base {
    Modifier.position(Position.Absolute).top(0.px).left(0.px).fillMaxSize().styleModifier {
        property(
            "background", "linear-gradient(180deg, rgba(0,0,0,0.05) 0%, rgba(0,0,0,0.15) 55%, rgba(0,0,0,0.55) 100%)"
        )
    }
}

val YtPlayButtonStyle = CssStyle {
    base {
        Modifier.position(Position.Absolute).top(50.percent).left(50.percent)
            // BULLETPROOF CENTERING: Half of the 88px size
            .margin(top = (-44).px, left = (-44).px)
            .size(88.px).borderRadius(50.percent)
            .backgroundColor(colorMode.toSitePalette().brand.primaryBlue).color(Colors.White).display(DisplayStyle.Flex)
            .alignItems(com.varabyte.kobweb.compose.css.AlignItems.Center)
            .justifyContent(com.varabyte.kobweb.compose.css.JustifyContent.Center)
            .boxShadow(0.px, 10.px, 30.px, color = Colors.Black.copy(alpha = 45))
            .transition(Transition.of("transform", 220.ms), Transition.of("background-color", 220.ms))
    }
    hover {
        Modifier.transform { scale(1.08) }
            .backgroundColor(Colors.White).color(colorMode.toSitePalette().brand.primaryBlue)
    }
}
val YtPulseAnimation = Keyframes {
    0.percent {
        Modifier.transform { scale(1) }.opacity(0.75)
    }
    70.percent {
        Modifier.transform { scale(1.6) }.opacity(0)
    }
    100.percent {
        Modifier.transform { scale(1.6) }.opacity(0)
    }
}

// 2. Apply it to your ring style
val YtPulseRingStyle = CssStyle.base {
    Modifier.position(Position.Absolute).top(50.percent).left(50.percent)
        .margin(top = (-44).px, left = (-44).px)
        .size(88.px).borderRadius(50.percent)
        .border(2.px, LineStyle.Solid, colorMode.toSitePalette().brand.primaryBlue)
        // CRITICAL: Hide the rings before their delayed animations start
        .opacity(0)
        .animation(
            YtPulseAnimation.toAnimation(
                duration = 2.2.s,
                timingFunction = AnimationTimingFunction.EaseOut,
                iterationCount = AnimationIterationCount.Infinite
            )
        )
        .styleModifier {
            property("pointer-events", "none")
        }
}

val YtLabelPillStyle = CssStyle.base {
    Modifier.position(Position.Absolute).top(16.px).left(16.px).padding(topBottom = 6.px, leftRight = 12.px)
        .borderRadius(999.px).backgroundColor(Colors.Black.copy(alpha = 160)).color(Colors.White).fontSize(12.px)
        .fontWeight(600).letterSpacing(0.5.px)
}

val YtIframeStyle = CssStyle.base {
    Modifier.position(Position.Absolute)
        .top(50.percent)
        .left(0.px)
        .transform { translateY((-50).percent) }
        .fillMaxWidth()
        .styleModifier { property("aspect-ratio", "16 / 9") }
        .backgroundColor(Colors.Black)
}